import { Box, Div, H5 } from '@vgrubs/components';
import { ReactNode } from 'react';

type Props = {
  title: string;
  /** Right-aligned control in the title row: a button, a download icon. */
  action?: ReactNode;
  children: ReactNode;
};

/** One titled card on the verification screen, so every section reads the same way. */
export const SectionCard = ({ title, action, children }: Props) => (
  <Box $p="20px 24px" $pSM="16px">
    <Div $flex $alignCenter $between $gap="12px" $mb="12" $wrap>
      <H5 $m="0">{title}</H5>
      {action}
    </Div>
    {children}
  </Box>
);
